import { Component, Vue } from 'vue-property-decorator';
@Component
export default class MenuEventsMixin extends Vue {
  get eventsUsagePercent(): number {
    const {
      eventsUsed,
      eventsIncluded,
    } = this.$store.state.billing;

    return eventsUsed / eventsIncluded  * 100;
  }

  get isNavbarEventsRed(){
    return this.eventsUsagePercent > 90;
  }
}